import {
  Box,
  Button,
  Checkbox,
  FormControlLabel,
  Typography,
} from "@mui/material";
import ClientChip from "../shared/client-chip";
import AddClientAutocomplete from "../shared/add-client-autocomplete";
import { Client } from "../../types/client";

interface ExpandedClientViewProps {
  displayedClients: Client[];
  unselectedClients: Client[];
  selectAll: boolean;
  selectedCount: number;
  onClientToggle: (id: string) => void;
  onSelectAll: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onAddClient: (client: Client | null) => void;
  onShowResults: () => void;
}

const ExpandedClientView = ({
  displayedClients,
  unselectedClients,
  selectAll,
  selectedCount,
  onClientToggle,
  onSelectAll,
  onAddClient,
  onShowResults,
}: ExpandedClientViewProps) => {
  return (
    <>
      <Box sx={{ display: "flex" }}>
        <Box
          sx={{
            display: "flex",
            flexWrap: "wrap",
            gap: 1,
            alignItems: "flex-start",
            width: "95%",
          }}
        >
          {displayedClients.map((client) => (
            <ClientChip
              key={client.id}
              label={client.name}
              selected={client.selected}
              onToggle={() => onClientToggle(client.id)}
            />
          ))}
          <FormControlLabel
            control={
              <Checkbox
                checked={selectAll}
                onChange={onSelectAll}
                size="small"
                sx={{ p: "6px" }}
              />
            }
            label={<Typography variant="caption">Select All</Typography>}
            sx={{ m: 0 }}
          />
        </Box>

        <Box
          sx={{
            marginLeft: "auto",
            flexShrink: 0,
            alignSelf: "flex-start",
            textAlign: "right",
          }}
        >
          <AddClientAutocomplete
            options={unselectedClients}
            onClientAdd={onAddClient}
            disabled={unselectedClients.length === 0}
          />
        </Box>
      </Box>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          mt: 2,
        }}
      >
        <Typography variant="caption" color="text.secondary">
          Viewing combined data for {selectedCount} client
          {selectedCount === 1 ? "" : "s"}
        </Typography>
        <Button
          variant="contained"
          onClick={onShowResults}
          disabled={selectedCount === 0}
          size="small"
        >
          Show Results
        </Button>
      </Box>
    </>
  );
};

export default ExpandedClientView;
